import React from "react";
import { FaDesktop, FaMobileAlt, FaAndroid, FaCheckCircle, FaPauseCircle, FaCog, FaRegCheckCircle, FaTimesCircle, FaUserTie, FaShoppingCart, FaGlobe } from "react-icons/fa";
import { FaClipboardList, FaRegCircle } from "react-icons/fa6";

const OrderStatus = () => {
    const statuses = [
        { name: "New", icon: <FaRegCircle size={20} />, color: "text-blue-500" },
        { name: "Confirmed", icon: <FaCheckCircle size={20} />, color: "text-green-500" },
        { name: "On-Hold", icon: <FaPauseCircle size={20} />, color: "text-yellow-500" },
        { name: "In-Process", icon: <FaCog size={20} />, color: "text-purple-500" },
        { name: "Complete", icon: <FaRegCheckCircle size={20} />, color: "text-gray-500" },
        { name: "Cancelled", icon: <FaTimesCircle size={20} />, color: "text-red-500" },
    ];
    return (

        <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">
            
            <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
                <FaClipboardList className="text-4xl text-theme-logo-color mr-3" />
                <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Order Status</h1>
            </div>



            {/* Tags Section */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
                <div className="flex flex-wrap gap-3">
                    {/* Seller Tag */}
                    <span className="flex items-center gap-2 bg-pink-100 text-pink-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-pink-200 transition">
                        <FaUserTie className="text-pink-600" />
                        Seller
                    </span>

                    <span className=" flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-green-200 transition">
                        <FaShoppingCart className="text-green-600" />
                        Buyer
                    </span>
                </div>

                <div className="flex flex-wrap gap-3">
                    {/* Web Tag */}
                    <span className="flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-blue-200 transition">
                        <FaGlobe className="text-blue-600" />
                        Web
                    </span>

                    {/* Android Tag */}
                    <span className="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-green-200 transition">
                        <FaAndroid className="text-green-600" />
                        Android
                    </span>
                </div>
            </div>

            {/* Intro Text */}
            <div className="bg-gray-50 p-6 rounded-2xl ">
                <p className="text-gray-700 text-start text-base leading-relaxed ">
                    Selzor user-friendly ordering system allows both 'Buyers' and 'Suppliers' to quickly access past orders from a chosen supplier or buyer. On the web app, up to 25 recent orders can be viewed directly within the order cart, while on the mobile app, the last 25 orders are just a tap away.
                </p>

            </div>

            <div className=" mx-auto p-6 bg-white rounded-3xl  border border-gray-200">

                <p className="text-gray-700 text-center mb-8">
                    Track the stage of every order on the Selzor Ordering Platform.
                    Each status is color-coded for easy recognition.
                </p>

                {/* Status Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
                    {statuses.map((status) => (
                        <div
                            key={status.name}
                            className="flex items-center p-4 bg-gray-50 rounded-xl shadow hover:shadow-lg transition-shadow duration-300"
                        >
                            <div
                                className={`w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 ${status.color} mr-4 text-2xl`}
                            >
                                {status.icon}
                            </div>
                            <span className="font-semibold text-gray-800">{status.name}</span>
                        </div>
                    ))}
                </div>

                {/* Description */}
                <div className="space-y-4 text-start text-gray-700 text-base sm:text-lg leading-relaxed">
                    <p className="">
                        When a new order is received, its status is marked as 'New'. This status can be updated to 'Confirmed', 'On-Hold', or 'In-Process' either individually or in bulk using Order Actions. A 'New' order can also be cancelled if needed.
                    </p>

                    <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300">
                        Buyers can cancel orders only when their status is 'New'. If the order has any other status, cancellation from the Selzor app is not allowed.
                    </div>
                    <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300">
                        Only 'Confirmed' & 'In-Process' Orders can be completed.
                    </div>
                    <div className="bg-red-100 text-red-600 p-4 rounded-lg border border-red-300">
                        After an order is marked as 'Complete' or 'Cancelled', it can no longer be edited.
                    </div>

                </div>
            </div>


        </div>
    );
};

export default OrderStatus;